import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, inrFormatter, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var axisLabelFontSize = chart.axisLabelFontSize + "px"

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam)
        .then(res => {
            let data = res.data
            var x1Scale = d3.scaleLinear().range([0, chart.width])
            var y1Scale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.1)
            var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way)
            var x1AxisLabel = d3.axisBottom(x1Scale).ticks(9).tickFormat(inrFormatter)
            var y1AxisLabel = d3.axisLeft(y1Scale)

            var svg = d3.select(divId).select("svg").remove();
            svg = d3.select(divId)
                .append('svg')
                .attr('width', chart.width + chart.margin.left + chart.margin.right)
                .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
                .call(responsivefy)
                .append('g')
                .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

            metric1ColorScale.domain(d3.keys(data[0]).filter((key) => {
                return key !== 'colorClass'
            }))
            data.forEach(function (d) {
                var y0 = 0
                d.values = metric1ColorScale.domain().map(function (name) {
                    return {name: name, y0: y0, y1: y0 += +d[name]}
                })
                d.total = d.values[d.values.length - 1].y1
            })

            x1Scale.domain([0, d3.max(data, d => {
                return d.total
            })])
            y1Scale.domain(data.map(d => {
                return d.colorClass
            }))

            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + chart.height + ')')
                .call(x1AxisLabel)
                .selectAll('text')
                .style('font-size', axisLabelFontSize)

            svg.append('g')
                .attr('class', 'y axis')
                .call(y1AxisLabel)
                .append('text')
                .attr('transform', 'rotate(-90)')
                .style('text-anchor', 'end')

            //var y1tip = d3.select(divId).append('tip').attr('class', 'tooltip')
            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            var bar = svg.selectAll('.bar')
                .data(data)
                .enter().append('g')
                .attr('class', 'g')
                .attr('transform', d => {
                    return 'translate(0, ' + y1Scale(d.colorClass) + ')'
                })
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    var elements = document.querySelectorAll(':hover')
                    var len = elements.length
                    len = len - 1
                    var element = elements[len].__data__
                    var value = element.y1 - element.y0

                    if (element.name === 'metric1') {
                        element.name = chart.y1MetricTooltip
                    } else if (element.name === 'metric2') {
                        element.name = chart.y2MetricTooltip
                    } else if (element.name === 'metric3') {
                        element.name = chart.x1MetricTooltip
                    }
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(element.name + colonAnnotation + numberFormat(value))
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            /*.on('mouseover', () =>{
                    y1tip.transition()
                        .duration(500)
                        .style('line-height', '1')
                        .style('padding', '12px')
                        .style('background', 'white')
                        .style('border-radius', '5px')
                        .style('position', 'absolute')
                        .style('border-width', '.1px')
                        .style('border-style', 'groove')

                    var elements = document.querySelectorAll(':hover')
                    var len = elements.length
                    len = len - 1
                    var element = elements[len].__data__
                    var value = element.y1 - element.y0

                    if (element.name === 'metric1') {
                        element.name = chart.y1MetricTooltip
                    } else if (element.name === 'metric2') {
                        element.name = chart.y2MetricTooltip
                    } else if (element.name === 'metric3') {
                        element.name = chart.titleToolTip
                    }

                    y1tip.html(element.name + colonAnnotation + numberFormat(value))
                        .style('left', '50%')
                        .style('top', '30%')
                        .style('display', 'inline-block')
                        .style('opacity', 1)
                })
                .on('mouseout', ()=> { y1tip.transition().duration(500).style('opacity', 0)})*/
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            var bar_enter = bar.selectAll('rect').data(d => {
                return d.values
            }).enter()

            bar_enter.append('rect')
                .attr('height', y1Scale.bandwidth())
                .attr('x', d => {
                    return x1Scale(d.y0)
                })
                .attr('width', d => {
                    return x1Scale(d.y1) - x1Scale(d.y0)
                })
                .style('fill', d => {
                    return metric1ColorScale(d.name)
                })

            bar_enter.append('text')
                .text(() => {
                    return inrFormatter(data.map(d => d.metric1))
                })
                .attr('x', (d) => {
                    return x1Scale(d.y1) + (x1Scale(d.y0) - x1Scale(d.y1) + 20)
                })
                .attr('y', y1Scale.bandwidth() / 1.5)
                .style('fill', '#e6e6e6')
        })
}
